import { WIDGET_KEYS as WIDGET, WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import UserEditorBase from "./UserEditorBase.jsx";
import {MessageDialog} from "@bryntum/schedulerpro";
import {defaultAddDeleteButton, getRolesWithoutPublic, getUserGrantsTextOnly, showToast} from "../../../other/utils/utils.jsx";

export default class UserGeneralTab extends UserEditorBase {
  static get $name() {
    return "UserGeneralTab";
  }

  // Factoryable type name
  static get type() {
    return "usergeneraltab";
  }

  get swivuDeepLinkSlug() {
    return "general";
  }

  static get configurable() {
    return {
      title: "General",
      autoUpdateFields: true,
      layoutStyle: {
        flexDirection: "column",
        justifyContent: "space-between",
        flexFlow: "column nowrap",
      },
      items: {
        fieldsContainer: {
          scrollable: {
            overflowX: "hidden",
            overflowY: "auto",
          },
          type: "container",
          defaults: {
            labelWidth: "8em",
            flex: "1 0 100%",
          },
          items: {
            description: {
              type: "text",
              html: "",
              cls: "b-text",
              flex: "1 0 100%",
            },
            userName: {
              type: "text",
              name: "name",
              label: "User Name",
              flex: "1 0 100%",
              required: true,
              onChange: 'up.onRecordChange'
            },
            userEmail: {
              type: WIDGET_KEYS.fieldEmail,
              label: "Email",
              placeholder: "Swivu users must have a Gmail or Google Workspace account. More options comming soon.",
              name: "email",
              flex: "1 0 100%",
              required: true,
              onChange: 'up.onRecordChange'
            },
            userRole: {
              name: "roles",
              type: "combo",
              displayField: "name",
              valueField: "id",
              label: "Role",
              placeholder: "Select Role",
              onChange: 'up.onChangeUserRole',
              required: true
            },
            userRolePermissions: {
              name: "Permissions",
              type: "display",
              label: "Permissions",
              template: () => "<p class='b-html'>Please select a role to see permissions</p>",
              cls: "user-permissions-text-cls",
            }
          },
        },
        bbarContainer: {
          type: "container",
          layoutStyle: {
            justifyContent: "flex-end",
          },
          items: defaultAddDeleteButton({
            addButton: {text: "Save", icon: "fa-solid fa-floppy-disk", onClick: "up.onSaveUser", cls: "mb-[0.5em] gap-[0.5em]"},
          })
        }
      },
    };
  }

  loadRecord(record, context) {
    const {userRole, addButton, description} = this.widgetMap;
    userRole.store = getRolesWithoutPublic(context.boardManager.boardNameStore.appRoles);
    this.context = context;

    super.loadRecord(record, context);

    userRole.disabled = record.userId === context.user.id;
    addButton.hidden = !record.isPhantom;

    const text = "Swivu does NOT send invitations. Adding user contacts is optional and can be done later. <br/> All users simply login at www.swivu.com. Desktop users use Swivu HQ (this app). Mobile users use Swivu Workforce.";
    if (record.isPhantom) {
      description.html = `<p class='leading-5 mb-3'>Enter a new board user; click save; and you are done! <br/> ${text}</p>`
    } else {
      description.html = `<p class='leading-5 mb-3'>${text}</p>`;
    }
  }

  onRecordChange({value, source, userAction}) {
    const {name: key} = source;
    if (userAction) {
      if (key === "name") {
        const swivuUserEditor = this.up(WIDGET.swivuUserPopup);
        swivuUserEditor.title = value;
      } else if (this.record.userId === this.context.user.id && key === "email") {
        source.setError("You cannot change your email address.")
      }
    } else if (key === "email") {
      /* If email is being updated via sync call or web socket then we are clearing error */
      source.clearError();
    }
  }

  onChangeUserRole({value}) {
    const {userRolePermissions} = this.widgetMap;
    const {boardManager} = this.context;
    const role = boardManager.boardNameStore.appRoles.find((record) => record.id === value);
    if (role && role.grants) {
      if (role.grants.length) {
        userRolePermissions.template = () => getUserGrantsTextOnly(role.grants).map((grant) => `<p class="b-html">${grant.description}</p>`).join("");
      } else {
        userRolePermissions.template = () => "<p class='b-html'>Please select a role to see permissions</p>";
      }
    }
  }

  async onSaveUser() {
    if (this.isValid) {
      const {addButton} = this.widgetMap;
      const boardUsersStore = this.context.project.boardUsersStore;
      const isUserEnteredEmailExists = boardUsersStore.find((record) => record.email && record.email.toLocaleLowerCase() === this.record.email.toLocaleLowerCase());
      if (isUserEnteredEmailExists) {
        await MessageDialog.alert({title: "Email exists", message: "The email is already in use!"});
      } else {
        boardUsersStore.add(this.record);
        addButton.hidden = true;
        showToast({msg: "A new user has been successfully added to this board.", type: "success"});
      }
    }
  }
}

UserGeneralTab.initClass();
